import { Controller } from "@hotwired/stimulus"

//
//== FANCYBOX
import { Fancybox } from "@fancyapps/ui";

export default class extends Controller {
  static values = { url: String }


  connect () {
    let scrollY = 0;

    Fancybox.bind("[data-fancybox]", {
      Toolbar: {
        display: {
          middle: [
            "zoomIn",
            "zoomOut",
            "toggle1to1",
          ],
          right: ["slideshow", "close"],
        },
      },
      on: {
        init:    () => { scrollY = window.scrollY; },
        destroy: () => { requestAnimationFrame(() => window.scrollTo(0, scrollY)); }
      }
    })
  }

  disconnect () {
    Fancybox.destroy();
  }

  async open(event) {
    event.preventDefault();

    const url = this.urlValue;
    if (!url) return;

    try {
      const response = await fetch(url, {
        headers: { Accept: "application/json" },
      });
      if (!response.ok) throw new Error("Failed to load images");

      const images = await response.json();

      Fancybox.show(
        images.map((img) => ({
          src: img.url,
          caption: img.caption || "",
          type: "image",
        }))
      );
    } catch (error) {
      console.error("Gallery load error:", error);
    }
  }
}
